import { Injectable, Injector } from '@angular/core';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { LazyLoadEvent } from 'primeng/primeng';
import { HttpParams } from '@angular/common/http';
import { PaymentReference } from '../entities/payment-reference';

@Injectable()
export class PaymentReferenceService extends BaseCrudService<PaymentReference> {

  public uri = '/api/paymentReference/';

  constructor(injector: Injector) {
    super(injector);
  }

  buildSentence(entity?: PaymentReference, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      if (entity.paymentDetail) {
        query = query.concat(
          `paymentDetail.id${QueryOperator.Equal}${entity.paymentDetail.id}${QueryOperator.Split}`
        );
      }
      if (entity.voucherMain) {
        query = query.concat(
          `voucherMain.id${QueryOperator.Equal}${entity.voucherMain.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }

    return this.httpParams;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/payment-reference.service.ts